import type { HTMLAttributes, PropsWithChildren } from 'react';
import { cn } from '../lib/cn';

export function Card({
  className,
  children,
  ...rest
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  return (
    <div
      className={cn(
        'bg-cream rounded-3xl shadow-soft border border-oud-100/60 p-5',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export function Ornament({ className }: { className?: string }) {
  return <div className={cn('ornament w-full', className)} />;
}
